export default "__VITE_ASSET__8f083556__"